import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../App";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { processGoogleAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL hash
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get("session_id");

        if (!sessionId) {
          toast.error("Authentifizierung fehlgeschlagen");
          navigate("/login");
          return;
        }

        await processGoogleAuth(sessionId);
        toast.success("Erfolgreich angemeldet!");
        
        // Clear hash and redirect
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard");
      } catch (error) {
        console.error("Auth error:", error);
        toast.error("Authentifizierung fehlgeschlagen");
        navigate("/login");
      }
    };

    processAuth();
  }, [navigate, processGoogleAuth]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-12 w-12 text-volt animate-spin mx-auto mb-4" />
        <p className="text-muted-foreground">Anmeldung wird verarbeitet...</p>
      </div>
    </div>
  );
}
